(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dwc-castor-guide"] && !Shopify.designMode) return;
  try {
    
  const alignCastorGuideVariantTitles = (scope = document) => {
    scope.querySelectorAll('.dwc-castor-guide--align-variant-titles').forEach((guide) => {
      guide.querySelectorAll('.dwc-castor-guide__diameter-row').forEach((row) => {
        const titles = Array.from(row.querySelectorAll('.dwc-castor-guide__type'));
        titles.forEach((title) => title.style.removeProperty('--guide-aligned-title-height'));
        const tallestTitle = titles.reduce((height, title) => Math.max(height, title.getBoundingClientRect().height), 0);
        titles.forEach((title) => title.style.setProperty('--guide-aligned-title-height', `${tallestTitle}px`));
      });
    });
  };

  let castorGuideResizeFrame;
  const queueCastorGuideTitleAlignment = (scope = document) => {
    cancelAnimationFrame(castorGuideResizeFrame);
    castorGuideResizeFrame = requestAnimationFrame(() => alignCastorGuideVariantTitles(scope));
  };

  queueCastorGuideTitleAlignment();
  window.addEventListener('load', () => queueCastorGuideTitleAlignment());
  window.addEventListener('resize', () => queueCastorGuideTitleAlignment());
  document.addEventListener('shopify:section:load', (event) => queueCastorGuideTitleAlignment(event.target));
  if (document.fonts?.ready) document.fonts.ready.then(() => queueCastorGuideTitleAlignment());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dwc-footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dwc-header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
